export const BULK_HELP_LINKS = {
  en: "https://support.okast.tv/en/support/solutions/articles/103000097691-upload-multiple-contents-at-once-bulk-upload-",
  fr: "https://support.okast.tv/fr/support/solutions/articles/103000097691-upload-multiple-de-contenus-bulk-upload-",
};
